<template>
  <v-card class="content-card" flat>
    <div class="content-card__body">
      <v-avatar class="content-card__avatar" size="60">
        <img
          v-if="iconSrc"
          :src="iconSrc"
          alt=""
          class="content-card__avatar-img"
        />
        <v-icon v-else class="content-card__avatar-icon">mdi-file-video</v-icon>
      </v-avatar>
      <div class="content-card__main">
        <div class="content-card__title-row">
          <h3 class="content-card__title">{{ title }}</h3>
          <v-menu
            v-if="showDotsMenu"
            v-model="menuOpen"
            :close-on-content-click="true"
            offset-x
            content-class="content-card__menu"
          >
            <template #activator="{ on, attrs }">
              <v-btn icon class="content-card__dots" v-bind="attrs" v-on="on">
                <v-icon class="content-card__dots-icon"
                  >mdi-dots-vertical</v-icon
                >
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item @click="copyLink">
                <v-list-item-title>Копировать ссылку</v-list-item-title>
              </v-list-item>
              <v-list-item @click="watchVideo">
                <v-list-item-title>Смотреть видео</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <v-btn
            v-else-if="showDownloadBtn"
            icon
            class="content-card__download"
            :href="link"
            target="_blank"
            rel="noopener noreferrer"
            @click="$emit('download', link)"
          >
            <img
              :src="downloadIconSrc"
              alt="Скачать"
              class="content-card__download-icon"
            />
          </v-btn>
        </div>
        <p
          class="content-card__subtitle"
          :class="{ 'content-card__subtitle--expanded': expanded }"
        >
          {{ subtitle }}
        </p>
        <v-btn
          v-if="showExpandBtn"
          text
          small
          color="primary"
          class="content-card__expand-btn pa-0 mt-1"
          @click="expanded = !expanded"
        >
          {{ expanded ? "Свернуть" : "Полное описание" }}
        </v-btn>
      </div>
    </div>
  </v-card>
</template>

<script>
const SUBTITLE_EXPAND_THRESHOLD = 300;

export default {
  name: "VideoMaterialCard",
  props: {
    title: {
      type: String,
      default: "",
    },
    subtitle: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "",
      /** Как табы и API: video | presentations | reviews */
      validator: (v) => ["", "video", "presentations", "reviews"].includes(v),
    },
    icon: {
      type: String,
      default: "",
    },
    link: {
      type: String,
      default: "",
    },
    videoUrl: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      menuOpen: false,
      expanded: false,
    };
  },
  computed: {
    iconSrc() {
      if (this.icon) return this.icon;
      const map = {
        video: require("./assets/video-card-icon.svg"),
        presentations: require("./assets/presa-card-icon.svg"),
        reviews: require("./assets/review-card-icon.svg"),
      };
      return this.type ? map[this.type] || "" : "";
    },
    showDotsMenu() {
      return this.type === "video" || this.type === "reviews";
    },
    showDownloadBtn() {
      return this.type === "presentations";
    },
    downloadIconSrc() {
      return require("./assets/download-icon.svg");
    },
    showExpandBtn() {
      if (!this.subtitle) return false;
      return this.subtitle.length >= SUBTITLE_EXPAND_THRESHOLD;
    },
  },
  methods: {
    copyLink() {
      const url = this.link || window.location.href;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(() => {
          this.$emit("link-copied");
        });
      } else {
        this.$emit("copy-link", url);
      }
      this.menuOpen = false;
    },
    watchVideo() {
      const url = this.videoUrl || this.link;
      if (url) window.open(url, "_blank");
      this.$emit("watch-video", url);
      this.menuOpen = false;
    },
  },
};
</script>

<style scoped>
.content-card {
  font-family: "Manrope", sans-serif;
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 16px;
  box-shadow: none;
}

.content-card__body {
  display: flex;
  align-items: flex-start;
  gap: 16px;
}

.content-card__avatar {
  flex-shrink: 0;
  background: #f0f8f6 !important;
}

.content-card__avatar-img {
  width: 32px;
  height: 32px;
  object-fit: contain;
}

.content-card__avatar-icon {
  font-size: 32px;
  color: #23919e;
}

.content-card__main {
  flex: 1;
  min-width: 0;
}

.content-card__title-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 8px;
}

.content-card__title {
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.4;
  color: rgba(0, 0, 0, 0.87);
  flex: 1;
  min-width: 0;
}

.content-card__dots {
  flex-shrink: 0;
  width: 32px !important;
  height: 32px !important;
  min-width: 32px !important;
  min-height: 32px !important;
  margin: -4px -4px 0 0;
}

.content-card__dots-icon {
  font-size: 32px !important;
}

.content-card__download {
  flex-shrink: 0;
  width: 32px !important;
  height: 32px !important;
  min-width: 32px !important;
  min-height: 32px !important;
  margin: -4px -4px 0 0;
}

.content-card__download-icon {
  width: 32px;
  height: 32px;
  display: block;
  object-fit: contain;
}

.content-card__subtitle {
  margin: 0;
  font-size: 16px;
  line-height: 1.5;
  color: rgba(0, 0, 0, 0.7);
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  white-space: pre-wrap;
  word-break: break-word;
}

.content-card__subtitle--expanded {
  -webkit-line-clamp: unset;
  line-clamp: unset;
  display: block;
}

.content-card__expand-btn {
  text-transform: none;
  font-size: 14px !important;
  min-height: auto;
}
</style>
